import React, {FC, ReactElement} from "react";
import {useEnabledFeatures} from "@core-ui/react-stitch";
import {ProductCardNameProps} from "./types";
import {CardName} from "../../styled";

const ProductCardName: FC<ProductCardNameProps> = ({
  clickable,
  name,
  link,
  onClick,
  displayAsRow,
}: ProductCardNameProps): ReactElement => {
  const enabledFeatures = useEnabledFeatures();
  const productName = (
    <CardName
      dangerouslySetInnerHTML={{__html: name}}
      displayAsRow={displayAsRow}
      enabledFeatures={enabledFeatures}
    />
  );

  if (clickable) {
    return (
      <a href={link} onClick={onClick}>
        {productName}
      </a>
    );
  }

  return productName;
};

export default ProductCardName;
